import { render } from "./SmartCardNotification.vue?vue&type=template&id=37f77630&scoped=true"
import script from "./SmartCardNotification.vue?vue&type=script&lang=js"
export * from "./SmartCardNotification.vue?vue&type=script&lang=js"

import "./SmartCardNotification.vue?vue&type=style&index=0&id=37f77630&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37f77630"

export default script